<template>
	<div v-if="user !== null && showButton">
		<div v-if="!sameUsername">
			<div v-if="from === 'resultCard'">
				<ion-icon
					v-if="!alreadyFollowing"
					@click.prevent="followUser"
					name="ios-add-circle"
					:title="`Follow ${user.username}`"
				></ion-icon>
				<ion-icon
					v-else
					@click.prevent="unfollowUser"
					name="ios-remove-circle"
					:title="`Unfollow ${user.username}`"
				></ion-icon>
			</div>
			<div v-else>
				<button
					v-if="!alreadyFollowing"
					class="stackng-button follow-button button"
					@click.prevent="followUser"
					:disabled="sameUsername || noUsername"
					:title="`Follow ${user.username}`"
				>
					<ion-icon name="add"></ion-icon>&nbsp;
					Follow
				</button>
				<button
					v-else
					class="stackng-button unfollow-button button"
					@click.prevent="unfollowUser"
					:title="`Unfollow ${user.username}`"
				>
					<ion-icon name="remove"></ion-icon>&nbsp;
					Unfollow
				</button>
			</div>
			<span class="no-username" v-if="noUsername">Create a username to follow {{user.username}}</span>
		</div>
	</div>
</template>

<script>
import { db } from "../../../resources/firebase";
import firebase from "firebase/app";
import "firebase/firestore";
import { sendNotification } from "../../../api/notifications";

export default {
	data() {
		return {
			userToFollowing: "",
			userToFollowers: "",
			alreadyFollowing: null,
			toastMessage: "Following",
			showButton: false
		};
	},
	props: {
		user: {
			type: Object
		},
		from: {
			type: String,
			required: false
		}
	},
	computed: {
		sameUsername() {
			return this.$store.state.user.user.username === this.user.username;
		},
		noUsername() {
			return this.$store.state.user.user.username === "";
		},
		authUserView() {
			return (
				this.$store.state.user.user.username === this.$route.params.username
			);
		}
	},
	beforeMount() {
		this.checkIfFollowing();
	},
	methods: {
		followUser() {
			if (this.$store.state.user.user.username !== "") {
				if (this.$store.state.user.authUser.emailVerified) {
					this.addToFollowing();
					this.addToFollowers();
				} else {
					this.showModal("verify-email");
				}
			} else {
				this.toastMessage = "Create a username";

				//Show toast
				this.$toasted.show(`${this.toastMessage}`, {
					theme: "bubble",
					position: "bottom-center",
					duration: 2500,
					className: ["error-toast"]
				});
			}
		},
		unfollowUser() {
			// const unfollowButton = document.querySelector('#unfollow-user')
			// unfollowButton.classList.add('is-loading')
			let authUserID = this.$store.state.user.authUser.uid;
			let followersCount = 0;
			let followingCount = 0;

			db.collection("users")
				.where("userID", "==", this.user.userID || this.user.objectID)
				.get()
				.then(snapshot => {
					//Get followersCount
					snapshot.forEach(doc => {
						followersCount = doc.data().followers.length;
						followingCount = doc.data().following.length;
					});
				})
				.then(() => {
					//Unfollow user
					db.collection("users")
						.doc(this.user.userID || this.user.objectID)
						.update({
							followers: firebase.firestore.FieldValue.arrayRemove(authUserID),
							followersCount: followersCount - 1
						})
						.then(() => {
							//Remove from userView followers state
							if (this.user.username === this.$route.params.username) {
								this.$store.commit("removeUserFollowers", authUserID);
							} else if (this.authUserView) {
								this.$store.commit(
									"removeAuthUserFollowing",
									this.user.userID || this.user.objectID
								);
							}

							//Remove from authUsers following
							db.collection("users")
								.doc(authUserID)
								.update({
									following: firebase.firestore.FieldValue.arrayRemove(
										this.user.userID || this.user.objectID
									),
									followingCount: followingCount - 1
								})
								.then(() => {
									this.checkIfFollowing();

									this.$toasted.show(`Unfollowed ${this.user.username}`, {
										theme: "bubble",
										position: "bottom-center",
										duration: 1500
									});

									setTimeout(() => {
										// unfollowButton.classList.remove('is-loading')
										// this.closeModal()
									}, 500);
								})
								.catch(error => {
									// console.log(error);
									throw new Error(error);
								});
						})
						.catch(error => {
							// console.log(error);
							throw new Error(error);
						});
				})
				.catch(error => {
					// console.log(error);
					throw new Error(error);
				});
		},
		showModal(action) {
			const html = document.querySelector("html");
			const app = document.querySelector("#app");
			app.classList.add("blur-app");
			html.style.overflowY = "hidden";

			if (action === "delete") {
				let payload = {
					show: true,
					user: this.user
				};

				this.unfollowUser();

				// this.$store.commit('updateUnfollowModal', payload)
			} else if (action === "verify-email") {
				let payload = {
					show: true,
					action: action
				};

				this.$store.commit("updateAccountModal", payload);
			}
		},
		addToFollowers() {
			this.userToFollowers = this.$store.state.user.authUser.uid;

			db.collection("users")
				.where("userID", "==", this.user.userID || this.user.objectID)
				.get()
				.then(snapshot => {
					const userDoc = snapshot.docs[0].id;

					//Get followersCount
					let followersCount = 0;
					snapshot.forEach(doc => {
						followersCount = doc.data().followers.length;
					});

					//Add/Remove userToFollow to authUser's following array
					if (!this.alreadyFollowing) {
						//Add authUser to user's followers
						db.collection("users")
							.doc(`${userDoc}`)
							.update({
								followers: firebase.firestore.FieldValue.arrayUnion(
									this.userToFollowers
								),
								followersCount: followersCount + 1
							})
							.then(() => {
								//Add to userView followers state
								if (this.user.username === this.$route.params.username) {
									this.$store.commit("addUserFollowers", this.userToFollowers);
								} else if (this.authUserView) {
									this.$store.commit("addAuthUserFollowing", userDoc);
									// this.$emit('addAuthUserFollowing', userDoc)
								}
							})
							.catch(error => {
								// console.log(error);
								throw new Error(error);
							});

						this.toastMessage = "Following";
					}

					//Update follow button
					this.checkIfFollowing();

					//Show toast
					this.$toasted.show(`${this.toastMessage} ${this.user.username}`, {
						theme: "bubble",
						position: "bottom-center",
						duration: 1500
					});
				})
				.catch(error => {
					// console.log(error);
					throw new Error(error);
				});
		},
		addToFollowing() {
			const authUserID = this.$store.state.user.authUser.uid;

			db.collection("users")
				.where("userID", "==", authUserID)
				.get()
				.then(snapshot => {
					const userDoc = snapshot.docs[0].id;

					//Get followingCount
					let followingCount = 0;
					snapshot.forEach(doc => {
						followingCount = doc.data().following.length;
					});

					//Add/Remove userToFollow to authUser's following array
					if (!this.alreadyFollowing) {
						db.collection("users")
							.doc(`${userDoc}`)
							.update({
								following: firebase.firestore.FieldValue.arrayUnion(
									this.user.userID || this.user.objectID
								),
								followingCount: followingCount + 1
							})
							.then(async () => {
								//Add to user's notifications
								let notification = {
									type: "follow",
									user: authUserID,
									dateCreated: Date.now(),
									seen: false
								};

								await sendNotification(this.user.userID || this.user.objectID, {
									...notification
								});
							});
					}
				})
				.catch(error => {
					// console.log(error);
					throw new Error(error);
				});
		},
		checkIfFollowing() {
			if (!this.sameUsername) {
				const authUserID = this.$store.state.user.authUser.uid;
				var userViewID;

				//Get user view id
				db.collection("users")
					.where("userID", "==", this.user.userID || this.user.objectID)
					.get()
					.then(snapshot => {
						snapshot.forEach(doc => {
							userViewID = doc.data().userID;
						});

						//Check if user view id is in auth user's following array
						db.collection("users")
							.where("userID", "==", authUserID)
							.get()
							.then(snapshot => {
								snapshot.forEach(doc => {
									this.alreadyFollowing = doc.data().following
										? doc.data().following.includes(userViewID)
										: false;
									this.showButton = true;
								});
							})
							.catch(error => {
								// console.log(error);
								throw new Error(error);
							});
					})
					.catch(error => {
						// console.log(error);
						throw new Error(error);
					});
			}
		}
	}
};
</script>

<style scoped>
ion-icon {
	font-size: 17px;
	cursor: pointer;
}

ion-icon[name="ios-add-circle"] {
	font-size: 20px;
	color: #51c715;
	border-radius: 50%;
	border: 2px solid #51c715;
	vertical-align: -webkit-baseline-middle;
}

ion-icon[name="ios-remove-circle"] {
	font-size: 20px;
	color: #595959;
	border-radius: 50%;
	border: 2px solid #595959;
	vertical-align: -webkit-baseline-middle;
}

button {
	margin-top: 10px;
	margin-right: 0px;
	outline: none !important;
	width: 100px;
	padding-left: 10px;
	padding-right: 10px;
}

.unfollow-button,
.unfollow-button:focus,
.unfollow-button:hover {
	background-color: #000;
	border-color: #000;
}

.no-username {
	margin-top: 15px;
	display: block;
}

.no-username,
.already-following p {
	color: #b7b7b7;
	font-size: 11px;
}

.already-following {
	margin-top: 15px;
}
</style>



// WEBPACK FOOTER //
// src/components/users/userView/UserFollowButton.vue